import React from 'react';
import { Row, Col } from 'reactstrap'
import Viz from 'components/Tableau/Viz';

const NailPriceVisualizer = (props) => {

  return (
    <>
      <Row>
        <Col>
          <Viz url='https://tableau.deacero.com/views/NailPriceVisualizerV2/Dashboard2/3fef2726-9cda-44bc-b7b9-7ed9f432f5d3/a9965757-3d12-407f-8cb9-655c7621949c' />
        </Col>
      </Row>
    </>
    
  )

}

export default NailPriceVisualizer;